module.exports = __webpack_public_path__ + "img/LCW.6b8c05f0.jpg";